import { Activity, Droplets, Gauge } from "lucide-react"
import { useIntl } from "react-intl"

export default function MetricsCards({ selectedJob, lastVerified, lastVerifiedLoading, lastVerifiedError }) {
  const intl = useIntl()
  const selected = Boolean(selectedJob?.id)

  const ts = lastVerified?.fechaMedicion && lastVerified?.horaMedicion
    ? intl.formatDate(new Date(`${lastVerified.fechaMedicion}T${lastVerified.horaMedicion}`), {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    })
    : ''

  const statusText = !selected
    ? intl.formatMessage({ id: "dga.common.selectJobData", defaultMessage: "Select a job to show it's data" })
    : lastVerifiedLoading
      ? intl.formatMessage({ id: "dga.metrics.loadingLatest", defaultMessage: "Loading latest submission…" })
      : lastVerifiedError
        ? intl.formatMessage({ id: "dga.metrics.failedLatest", defaultMessage: "Failed to load latest submission" })
        : lastVerified
          ? `${ts || '—'}`
          : intl.formatMessage({ id: "dga.metrics.noVerified", defaultMessage: "No verified submissions yet" })

  // Values from latest verified record
  const totalizer = lastVerified?.totalizadorM3
  const flow = lastVerified?.caudalLps
  const waterLevelM = lastVerified?.nivelFreaticoM

  return (
    <div className="grid grid-cols-1 md:!grid-cols-3 gap-4">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
        <div className="flex flex-row items-center justify-between space-y-0 pb-2 p-6">
          <h3 className="text-sm font-medium">
            {intl.formatMessage({ id: "dga.metrics.totalizer", defaultMessage: "Totalizer" })}
          </h3>
          <Gauge className="h-4 w-4 text-purple-600" />
        </div>
        <div className="px-6 pb-6">
          <div className="text-2xl font-bold">
            {totalizer !== null && totalizer !== undefined && totalizer !== ""
              ? `${intl.formatNumber(totalizer, { useGrouping: true })} m³`
              : "—"}
          </div>
          <p className="text-xs text-gray-600">{statusText}</p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
        <div className="flex flex-row items-center justify-between space-y-0 pb-2 p-6">
          <h3 className="text-sm font-medium">
            {intl.formatMessage({ id: "dga.metrics.waterLevel", defaultMessage: "Water Level" })}
          </h3>
          <Droplets className="h-4 w-4 text-emerald-600" />
        </div>
        <div className="px-6 pb-6">
          <div className="text-2xl font-bold">
            {waterLevelM !== null && waterLevelM !== undefined && waterLevelM !== ""
              ? `${intl.formatNumber(waterLevelM, { useGrouping: true })} m`
              : "—"}
          </div>
          <p className="text-xs text-gray-600">{statusText}</p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
        <div className="flex flex-row items-center justify-between space-y-0 pb-2 p-6">
          <h3 className="text-sm font-medium">
            {intl.formatMessage({ id: "dga.metrics.flowRate", defaultMessage: "Flow Rate" })}
          </h3>
          <Activity className="h-4 w-4 text-blue-600" />
        </div>
        <div className="px-6 pb-6">
          <div className="text-2xl font-bold">
            {flow !== null && flow !== undefined && flow !== ""
              ? `${intl.formatNumber(flow, { useGrouping: true })} L/s`
              : "—"}
          </div>
          <p className="text-xs text-gray-600">{statusText}</p>
        </div>
      </div>
    </div>
  )
}
